import React from "react";
import "./footer.scss";

function Footer() {
  return <div className="footer">Netflix</div>;
}

export default Footer;
